import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './module/home';
import {InquiryComponent} from './module/home/virtual-account/mandiri/inquiry/inquiry.component';
import {PaymentComponent} from './module/home/virtual-account/mandiri/payment/payment.component';
import {InquiryComponent as InquiryBcaComponent} from './module/home/virtual-account/bca/inquiry/inquiry.component';
import {PaymentComponent as PaymentBcaComponent} from './module/home/virtual-account/bca/payment/payment.component';
import {InquiryPermataComponent} from './module/home/virtual-account/permata/inquiry-permata/inquiry-permata.component';
import {PaymentPermataComponent} from './module/home/virtual-account/permata/payment-permata/payment-permata.component';
import {PaymentResultPermataComponent} from './module/home/virtual-account/permata/payment-result-permata/payment-result-permata.component';
import {
  InquiryMandiriSyariahComponent
} from './module/home/virtual-account/mandiri-syariah/inquiry-mandiri-syariah/inquiry-mandiri-syariah.component';
import {
  PaymentMandiriSyariahComponent
} from './module/home/virtual-account/mandiri-syariah/payment-mandiri-syariah/payment-mandiri-syariah.component';
import {InquiryDanamonComponent} from './module/home/virtual-account/danamon/inquiry-danamon/inquiry-danamon.component';
import {PaymentDanamonComponent} from './module/home/virtual-account/danamon/payment-danamon/payment-danamon.component';
import {PaymentResultDanamonComponent} from './module/home/virtual-account/danamon/payment-result-danamon/payment-result-danamon.component';
import {PageUnauthorizedComponent} from './module/page-unauthorized/page-unauthorized.component';
import {CreditCardComponent} from './module/home/credit-card/credit-card.component';
import {InquiryOvoComponent} from './module/home/e-wallet/ovo/inquiry-ovo/inquiry-ovo.component';
import {PaymentOvoComponent} from './module/home/e-wallet/ovo/payment-ovo/payment-ovo.component';
import {PageNotFoundComponent} from './module/home/error-page/page-unauthorized/page-not-found/page-not-found.component';
import {PaymentResultOvoComponent} from './module/home/e-wallet/ovo/payment-result-ovo/payment-result-ovo.component';
import {InquiryBriSyariahComponent} from './module/home/virtual-account/bri-syariah/inquiry-bri-syariah/inquiry-bri-syariah.component';
import {PaymentBriSyariahComponent} from './module/home/virtual-account/bri-syariah/payment-bri-syariah/payment-bri-syariah.component';
import {
  PaymentResultBriSyariahComponent
} from './module/home/virtual-account/bri-syariah/payment-result-bri-syariah/payment-result-bri-syariah.component';
import {InquiryDokuVaComponent} from './module/home/virtual-account/doku-va/inquiry-doku-va/inquiry-doku-va.component';
import {PaymentDokuVaComponent} from './module/home/virtual-account/doku-va/payment-doku-va/payment-doku-va.component';
import {PaymentResultDokuVaComponent} from './module/home/virtual-account/doku-va/payment-result-doku-va/payment-result-doku-va.component';
import {PaymentResultBcaComponent} from './module/home/virtual-account/bca/payment-result-bca/payment-result-bca.component';
import {PaymentResultMandiriComponent} from './module/home/virtual-account/mandiri/payment-result-mandiri/payment-result-mandiri.component';
import {
  PaymentResultMandiriSyariahComponent
} from './module/home/virtual-account/mandiri-syariah/payment-result-mandiri-syariah/payment-result-mandiri-syariah.component';
import {InquiryAlfaComponent} from './module/home/convenience-store/alfa/inquiry-alfa/inquiry-alfa.component';
import {PaymentAlfaComponent} from './module/home/convenience-store/alfa/payment-alfa/payment-alfa.component';
import {PaymentResultAlfaComponent} from './module/home/convenience-store/alfa/payment-result-alfa/payment-result-alfa.component';
import {BriDirectDebitComponent} from './module/home/direct-debit/bri-direct-debit/bri-direct-debit.component';
import {InquiryBriComponent} from './module/home/virtual-account/bri/inquiry-bri/inquiry-bri.component';
import {PaymentBriComponent} from './module/home/virtual-account/bri/payment-bri/payment-bri.component';
import {PaymentResultBriComponent} from './module/home/virtual-account/bri/payment-result-bri/payment-result-bri.component';
import {ShopeePayComponent} from './module/home/e-wallet/shopee-pay/shopee-pay.component';
import {PaymentShopeepayComponent} from './module/home/e-wallet/shopee-pay/payment-shopeepay/payment-shopeepay.component';
import {
  PaymentResultShopeepayComponent
} from './module/home/e-wallet/shopee-pay/payment-result-shopeepay/payment-result-shopeepay.component';
import {InquiryCimbComponent} from './module/home/virtual-account/cimb/inquiry-cimb/inquiry-cimb.component';
import {PaymentCimbComponent} from './module/home/virtual-account/cimb/payment-cimb/payment-cimb.component';
import {PaymentResultCimbComponent} from './module/home/virtual-account/cimb/payment-result-cimb/payment-result-cimb.component';
import {InquiryIndomaretComponent} from './module/home/convenience-store/indomaret/inquiry-indomaret/inquiry-indomaret.component';
import {PaymentIndomaretComponent} from './module/home/convenience-store/indomaret/payment-indomaret/payment-indomaret.component';
import {
  PaymentResultIndomaretComponent
} from './module/home/convenience-store/indomaret/payment-result-indomaret/payment-result-indomaret.component';
import {DirectTransferBcaComponent} from './module/home/direct-transfer/direct-transfer-bca/direct-transfer-bca.component';
import {RekeningBersamaBcaComponent} from './module/home/rekening-bersama/rekening-bersama-bca/rekening-bersama-bca.component';
import {AkulakuComponent} from './module/home/paylater/akulaku/akulaku.component';
import {AkuLakuAuthComponent} from './module/home/paylater/akulaku/auth/akulakuauth.component';
import {AkuLakuInquiryComponent} from './module/home/paylater/akulaku/inquiry/akulakuinquiry.component';
import {KredivoComponent} from './module/home/paylater/kredivo/kredivo.component';
import {KredivoAuthComponent} from './module/home/paylater/kredivo/auth/kredivoauth.component';
import {KredivoInquiryComponent} from './module/home/paylater/kredivo/inquiry/kredivoinquiry.component';
import {AkuLakuAnotherPageComponent} from './module/home/paylater/akulaku/inquiry/akulakuanotherpage.component';
import {IndodanaAuthComponent} from './module/home/paylater/indodana/auth/indodanaauth.component';
import {IndodanaInquiryComponent} from './module/home/paylater/indodana/inquiry/indodanainquiry.component';
import {IndodanaComponent} from './module/home/paylater/indodana/indodana.component';
import {InquiryBniComponent} from './module/home/virtual-account/bni/inquiry-bni/inquiry-bni.component';
import {PaymentBNIComponent} from './module/home/virtual-account/bni/payment-bni/payment.bni.component';
import {PaymentResultBniComponent} from './module/home/virtual-account/bni/payment-result-bni/payment-result-bni.component';
import {PaymentBNCComponent} from './module/home/virtual-account/bnc/payment-bnc/payment.bnc.component';
import {InquiryBncComponent} from './module/home/virtual-account/bnc/inquiry-bnc/inquiry-bnc.component';
import {PaymentResultBncComponent} from './module/home/virtual-account/bnc/payment-result-bnc/payment-result-bnc.component';
import {InquiryBtnComponent} from './module/home/virtual-account/btn/inquiry-btn/inquiry-btn.component';
import {PaymentBtnComponent} from './module/home/virtual-account/btn/payment-btn/payment-btn.component';
import {PaymentResultBtnComponent} from './module/home/virtual-account/btn/payment-result-btn/payment-result-btn.component';
import {InquiryMandiriSnapComponent} from './module/home/virtual-account/mandiri-snap/inquiry-mandiri-snap/inquiry-mandiri-snap.component';
import {PaymentMandiriSnapComponent} from './module/home/virtual-account/mandiri-snap/payment-mandiri-snap/payment-mandiri-snap.component';
import {
  PaymentResultMandiriSnapComponent
} from './module/home/virtual-account/mandiri-snap/payment-result-mandiri-snap/payment-result-mandiri-snap.component';
import {InquiryBniSnapComponent} from './module/home/virtual-account/bni-snap/inquiry-bni-snap/inquiry-bni-snap.component';
import {PaymentBniSnapComponent} from './module/home/virtual-account/bni-snap/payment-bni-snap/payment-bni-snap.component';
import {
  PaymentResultBniSnapComponent
} from './module/home/virtual-account/bni-snap/payment-result-bni-snap/payment-result-bni-snap.component';
import {InquiryBriSnapComponent} from './module/home/virtual-account/bri-snap/inquiry-bri-snap/inquiry-bri-snap.component';
import {PaymentBriSnapComponent} from './module/home/virtual-account/bri-snap/payment-bri-snap/payment-bri-snap.component';
import {
  PaymentResultBriSnapComponent
} from './module/home/virtual-account/bri-snap/payment-result-bri-snap/payment-result-bri-snap.component';
import {IdentifyLinkAjaComponent} from './module/home/e-wallet/linkaja/linkaja-identify/linkaja-identify.component';
import {LoginLinkajaComponent} from './module/home/e-wallet/linkaja/linkaja-login/linkaja-login.component';
import {PaymentLinkajaComponent} from './module/home/e-wallet/linkaja/linkaja-payment/linkaja-payment.component';
import {PaymentResultLinkajaComponent} from './module/home/e-wallet/linkaja/linkaja-payment-result/linkaja-payment-result.component';
import {DanamonSnapInquiryComponent} from './module/home/virtual-account/danamon-snap/danamon-snap-inquiry/danamon-snap-inquiry.component';
import {DanamonSnapPaymentComponent} from './module/home/virtual-account/danamon-snap/danamon-snap-payment/danamon-snap-payment.component';
import {
  DanamonSnapPaymentResultComponent
} from './module/home/virtual-account/danamon-snap/danamon-snap-payment-result/danamon-snap-payment-result.component';
import {MaybankSnapInquiryComponent} from './module/home/virtual-account/maybank-snap/maybank-snap-inquiry/maybank-snap-inquiry.component';
import {MaybankSnapPaymentComponent} from './module/home/virtual-account/maybank-snap/maybank-snap-payment/maybank-snap-payment.component';
import {
  MaybankSnapPaymentResultComponent
} from './module/home/virtual-account/maybank-snap/maybank-snap-payment-result/maybank-snap-payment-result.component';
import {
  PermataSnapPaymentResultComponent
} from './module/home/virtual-account/permata-snap/permata-snap-payment-result/permata-snap-payment-result.component';
import {PermataSnapPaymentComponent} from './module/home/virtual-account/permata-snap/permata-snap-payment/permata-snap-payment.component';
import {PermataSnapInquiryComponent} from './module/home/virtual-account/permata-snap/permata-snap-inquiry/permata-snap-inquiry.component';
import {KlikBcaInquiryComponent} from './module/home/virtual-account/klik-bca/klik-bca-inquiry/klik-bca-inquiry.component';
import {KlikBcaPaymentComponent} from './module/home/virtual-account/klik-bca/klik-bca-payment/klik-bca-payment.component';
import {
  KlikBcaPaymentResultComponent
} from './module/home/virtual-account/klik-bca/klik-bca-payment-result/klik-bca-payment-result.component';
import { InquiryBsiSnapComponent } from './module/home/virtual-account/bsi-snap/inquiry-bsi-snap/inquiry-bsi-snap.component';
import { PaymentBsiSnapComponent } from './module/home/virtual-account/bsi-snap/payment-bsi-snap/payment-bsi-snap.component';
import { PaymentResultBsiSnapComponent } from './module/home/virtual-account/bsi-snap/payment-result-bsi-snap/payment-result-bsi-snap.component';
const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '', component: HomeComponent,
      },
      {
        path: 'mandiri',
        children: [
          {
            path: 'inquiry', component: InquiryComponent
          },
          {
            path: 'payment', component: PaymentComponent
          },
          {
            path: 'payment-result', component: PaymentResultMandiriComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'mandiri-snap',
        children: [
          {
            path: 'inquiry', component: InquiryMandiriSnapComponent
          },
          {
            path: 'payment', component: PaymentMandiriSnapComponent
          },
          {
            path: 'payment-result', component: PaymentResultMandiriSnapComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'mandiri-syariah',
        children: [
          {
            path: 'inquiry', component: InquiryMandiriSyariahComponent
          },
          {
            path: 'payment', component: PaymentMandiriSyariahComponent
          },
          {
            path: 'payment-result', component: PaymentResultMandiriSyariahComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'danamon',
        children: [
          {
            path: 'inquiry', component: InquiryDanamonComponent
          },
          {
            path: 'payment', component: PaymentDanamonComponent
          },
          {
            path: 'payment-result', component: PaymentResultDanamonComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'danamon-snap',
        children: [
          {
            path: 'inquiry', component: DanamonSnapInquiryComponent
          },
          {
            path: 'payment', component: DanamonSnapPaymentComponent
          },
          {
            path: 'payment-result', component: DanamonSnapPaymentResultComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'maybank-snap',
        children: [
          {
            path: 'inquiry', component: MaybankSnapInquiryComponent
          },
          {
            path: 'payment', component: MaybankSnapPaymentComponent
          },
          {
            path: 'payment-result', component: MaybankSnapPaymentResultComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'permata-snap',
        children: [
          {
            path: 'inquiry', component: PermataSnapInquiryComponent
          },
          {
            path: 'payment', component: PermataSnapPaymentComponent
          },
          {
            path: 'payment-result', component: PermataSnapPaymentResultComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'permata',
        children: [
          {
            path: 'inquiry', component: InquiryPermataComponent
          },
          {
            path: 'payment', component: PaymentPermataComponent
          },
          {
            path: 'payment-result', component: PaymentResultPermataComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'klik-bca',
        children: [
          {
            path: 'inquiry', component: KlikBcaInquiryComponent
          },
          {
            path: 'payment', component: KlikBcaPaymentComponent
          },
          {
            path: 'payment-result', component: KlikBcaPaymentResultComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'bca',
        children: [
          {
            path: 'inquiry', component: InquiryBcaComponent
          },
          {
            path: 'payment', component: PaymentBcaComponent
          },
          {
            path: 'payment-result', component: PaymentResultBcaComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      }, {
        path: 'ovo',
        children: [
          {
            path: '', redirectTo: 'inquiry', pathMatch: 'full'
          }, {
            path: 'inquiry', component: InquiryOvoComponent
          }, {
            path: 'payment', component: PaymentOvoComponent
          }, {
            path: 'payment-result', component: PaymentResultOvoComponent
          }, {
            path: '**', component: PageNotFoundComponent
          }
        ]
      },
      {
        path: 'linkaja',
        children: [
          {
            path: '', redirectTo: 'identify', pathMatch: 'full'
          }, {
            path: 'identify', component: IdentifyLinkAjaComponent
          }, {
            path: 'login', component: LoginLinkajaComponent
          }, {
            path: 'payment', component: PaymentLinkajaComponent
          }, {
            path: 'payment-result', component: PaymentResultLinkajaComponent
          }, {
            path: '**', component: PageNotFoundComponent
          }
        ]
      },
      {
        path: 'shopeepay',
        children: [
          {
            path: '', component: ShopeePayComponent
          },
          {
            path: 'payment', component: PaymentShopeepayComponent
          }, {
            path: 'payment-result', component: PaymentResultShopeepayComponent
          }, {
            path: '**', component: PageNotFoundComponent
          }
        ]
      },
      {
        path: 'bri-syariah',
        children: [
          {
            path: 'inquiry', component: InquiryBriSyariahComponent
          },
          {
            path: 'payment', component: PaymentBriSyariahComponent
          },
          {
            path: 'payment-result', component: PaymentResultBriSyariahComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'doku-va',
        children: [
          {
            path: 'inquiry', component: InquiryDokuVaComponent
          },
          {
            path: 'payment', component: PaymentDokuVaComponent
          },
          {
            path: 'payment-result', component: PaymentResultDokuVaComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'cimb',
        children: [
          {
            path: 'inquiry', component: InquiryCimbComponent
          },
          {
            path: 'payment', component: PaymentCimbComponent
          },
          {
            path: 'payment-result', component: PaymentResultCimbComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'alfa',
        children: [
          {
            path: 'inquiry', component: InquiryAlfaComponent
          },
          {
            path: 'payment', component: PaymentAlfaComponent
          },
          {
            path: 'payment-result', component: PaymentResultAlfaComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'indomaret',
        children: [
          {
            path: 'inquiry', component: InquiryIndomaretComponent
          },
          {
            path: 'payment', component: PaymentIndomaretComponent
          },
          {
            path: 'payment-result', component: PaymentResultIndomaretComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'bri',
        children: [
          {
            path: 'inquiry', component: InquiryBriComponent
          },
          {
            path: 'payment', component: PaymentBriComponent
          },
          {
            path: 'payment-result', component: PaymentResultBriComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'bri-snap',
        children: [
          {
            path: 'inquiry', component: InquiryBriSnapComponent
          },
          {
            path: 'payment', component: PaymentBriSnapComponent
          },
          {
            path: 'payment-result', component: PaymentResultBriSnapComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'bni',
        children: [
          {
            path: 'inquiry', component: InquiryBniComponent
          },
          {
            path: 'payment', component: PaymentBNIComponent
          },
          {
            path: 'payment-result', component: PaymentResultBniComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'bni-snap',
        children: [
          {
            path: 'inquiry', component: InquiryBniSnapComponent
          },
          {
            path: 'payment', component: PaymentBniSnapComponent
          },
          {
            path: 'payment-result', component: PaymentResultBniSnapComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
          path: 'bnc',
          children: [
            {
              path: 'payment', component: PaymentBNCComponent
            },
            {
              path: 'inquiry', component: InquiryBncComponent
            },
            {
              path: 'payment-result', component: PaymentResultBncComponent
            },
            {
              path: '**', redirectTo: 'inquiry', pathMatch: 'full'
            }
          ]
      },
      {
        path: 'btn',
        children: [
          {
            path: 'inquiry', component: InquiryBtnComponent
          },
          {
            path: 'payment', component: PaymentBtnComponent
          },
          {
            path: 'payment-result', component: PaymentResultBtnComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'bsi-snap',
        children: [
          {
            path: 'inquiry', component: InquiryBsiSnapComponent
          },
          {
            path: 'payment', component: PaymentBsiSnapComponent
          },
          {
            path: 'payment-result', component: PaymentResultBsiSnapComponent
          },
          {
            path: '**', redirectTo: 'inquiry', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'credit-card', component: CreditCardComponent
      },
      {
        path: 'direct-debit-bri', component: BriDirectDebitComponent
      },
      {
        path: 'direct-transfer-bca', component: DirectTransferBcaComponent
      },
      {
        path: 'rekening-bersama-bca', component: RekeningBersamaBcaComponent
      },
      {
        path: 'paylater-akulaku', component: AkulakuComponent
      },
      {
        path: 'akulaku/payment', component: AkuLakuAuthComponent
      },
      {
        path: 'paylater-akulaku-inquiry', component: AkuLakuInquiryComponent
      },
      {
        path: 'paylater-kredivo', component: KredivoComponent
      },
      {
        path: 'kredivo/payment', component: KredivoAuthComponent
      },
      {
        path: 'paylater-kredivo-inquiry', component: KredivoInquiryComponent
      },
      {
        path: 'payment-done', component: AkuLakuAnotherPageComponent
      },
      {
        path: 'indodana/payment', component: IndodanaAuthComponent
      },
      {
        path: 'paylater-indodana-inquiry', component: IndodanaInquiryComponent
      },
      {
        path: 'paylater-indodana', component: IndodanaComponent
      }
    ]
  }, {
    path: 'unauthorized', component: PageUnauthorizedComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
